import { Skeleton } from "antd";
import { FC } from "react";

interface DirectLinksSkeletonProps {}

const DirectLinksSkeleton: FC<DirectLinksSkeletonProps> = ({}) => {
  return (
    <div className="bg-white px-6 py-8 rounded space-y-6 flex flex-col gap-2 justify-center items-center">
      <Skeleton.Button active className="self-end" />
      <Skeleton.Image active />
      <Skeleton.Input active />
    </div>
  );
};

export default DirectLinksSkeleton;
